export default {
  getLeadList: state => {
    return state.leadList;
  },

  getSourceList: state => {
    return state.sourceList;
  },

  getTotalItems: state => {
    return state.totalItems;
  },

  getTotalSourceItems: state => {
    return state.totalSourceItems;
  },

  getHistoricList: state => {
    return state.historicList;
  },

  getSearch: state => {
    return state.search;
  },

  isEmpty: state => {
    return !state.leadList.length;
  },

  isLoading: state => {
    return state.isLoading;
  }
};
